import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Home } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-zinc-950" data-testid="not-found-page">
      <Navbar />
      <div className="flex flex-col items-center justify-center h-[80vh] px-4">
        <h1 className="text-8xl font-bold text-amber-500 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Page Not Found</h2>
        <p className="text-zinc-400 mb-8 text-center max-w-md">
          The page you're looking for doesn't exist or you don't have permission to access it.
        </p>
        <Link to="/">
          <Button className="bg-amber-500 hover:bg-amber-600 text-black" data-testid="go-home-btn">
            <Home className="mr-2 h-4 w-4" />
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
